// import { FaBookmark } from "react-icons/fa";
import EventProgram from "./EventProgram";
// import { useRef, useState } from "react";
// import Banner from "./Banner";

const Presentation = () => {

    // const programButton = useRef(null);
    // const bannerButton = useRef(null);

    // const [activePresentationIsProgram, setActivePresentationIsProgram] = useState(true);

    // const switchPresentation = () => {
    //     programButton.current.classList.toggle("active");
    //     bannerButton.current.classList.toggle("active");
    //     setActivePresentationIsProgram(!activePresentationIsProgram);
    // }

    return (
        <section id="presentation">
            {/* <h2>
                <div className="select-banner-or-program">
                    <button ref={programButton} onClick={() => switchPresentation()} className="active">Etkinlik Programı</button>
                    <button ref={bannerButton} onClick={() => switchPresentation()}>Afiş</button>
                </div>
            </h2>
            {
                activePresentationIsProgram ? 
                <EventProgram /> : <Banner />
            } */}
            <h2>Etkinlik Programı</h2>
            <EventProgram />
            {/* <div className="present-buttons"> */}
                {/* <button className="active"><FaBookmark /> <span>Etkinlik Programı</span></button> */}
                
                {/* <button><FaBookmark /> <span>Afiş</span></button> */}
            {/* </div> */}
        </section>
    )
}

export default Presentation